/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/prop-types */
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { Attachment, Edit, Icon, InfoRound } from '@rsuite/icons';
import './style.css';
import {
  Table,
  FlexboxGrid,
  SelectPicker,
  IconButton,
  CheckPicker,
  Modal,
  Button,
} from 'rsuite';
import { toast } from 'react-toastify';
import { GerarCSV as CSV } from '~/utils/gerarCSV'
import { Container } from '~/styles/tabela1';
import pt from 'date-fns/locale/pt-BR';
import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import { formatDistance } from "date-fns";
import { TableHeaderLabel, TableHeaderTooltip, TablePagination } from '~/components/TablePagination1';
import api from '~/services/api';
import formatCurrency from '~/utils/formatCurrency';
import SearchInputTable from '~/components/SearchInputTable';
import { InputDataRange } from '~/components/InputDataRange';
import { FiltroTreinamentos } from '~/components/FiltroTreinamentos';
import { FcAlphabeticalSortingAz } from "react-icons/fc";
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import { TbCertificate } from 'react-icons/tb';
import { FaRegStar } from 'react-icons/fa';
import { MdOutlinePeopleOutline } from 'react-icons/md';
import EditarProfissional from '../../Profissionais/EditarProfissional';
import DetalhesCarteiraDialog from './components/DetalhesCarteiraDialog';
import SelectState from '../../../components/SelectState';
import PageHeader from '../../../components/PageHeader';
import MetricsCards from '../../../components/MetricCards';
import AdvancedFilters from '../../../components/AdvancedFilters';
import ActionCell from '../../Profissionais/components/ActionCell';
import { ProfissionalAddressCell } from '../../Profissionais/components/TableCells';

const { HeaderCell, Column, Cell } = Table;

function CarteiraProfissionais() {
  const [carteiraProfissionais, setCarteiraProfissionais] = useState({
    lista: [],
    quantidade: 0,
  });
  const [profissoes, setProfissoes] = useState([]);
  const [experienciaSelecionada, setExperienciaSelecionada] = useState();
  const [treinamentos, setTreinamentos] = useState([]);
  const [treinamentoSelecionado, setTreinamentoSelecionado] = useState();
  const [trabFeitosSelecionado, setTrabFeitosSelecionado] = useState();
  const [atributoSelecionado, setAtributoSelecionado] = useState('nome');
  const [modalConfirmacao, setModalConfirmacao] = useState(false);
  const [textodigitado, setTextoDigitado] = useState();
  const [estadoSelecionado, setEstadoSelecionado] = useState();
  const [ufSelecionado, setUfSelecionado] = useState();
  const [data, setData] = useState();
  const [pagina, setPagina] = useState(1);
  const [exibirDetalhesDialog, setExibirDetalhesDialog] = useState({
    exibir: false,
  });
  const [profissionalEditando, setProfissionalEditando] = useState();
  const [showEditarProfissional, setShowEditarProfissional] = useState(false);

  const [carregando, setCarregando] = useState(true);

  const [orderBy, setOrderBy] = useState('');
  const [buscarCSV, setBuscarCSV] = useState(false);

  const buscarCarteiraProfissionais = useCallback(async () => {
    setCarregando(true);
    setModalConfirmacao(false)
    try {
      const resposta = await api.get(`relatorios/carteira-profissionais`, {
        params: {
          [atributoSelecionado]: textodigitado,
          data,
          pagina,
          treinamentos: treinamentoSelecionado,
          experiencias: experienciaSelecionada,
          trabFeitos: trabFeitosSelecionado,
          estado: estadoSelecionado,
          orderBy,
          csvExport: buscarCSV
        },
      });
      const profissoes1 = await api.get('profissao');
      setProfissoes(profissoes1.data);
      const treinamentos1 = await api.get('treinamento');
      setTreinamentos(treinamentos1.data);

      const getDuration = (startDuration, stopoverDuration) => {
        const durationDateFrom = new Date(startDuration);
        const durationDateTo = new Date(stopoverDuration);
        return formatDistance(durationDateTo, durationDateFrom, {
          locale: pt,
        });
      }

      const lista = resposta.data.lista.map((item) => ({
        // ...item,
        ...(buscarCSV === false && item),
        'Nome': item.nome,
        'Bairro': item.bairro,
        'Cidade': item.cidade,
        'Avaliacao': item.avaliacao !== null ? `${item.avaliacao.toFixed(2)}` : `${'Não avaliado'}`,
        'Recebido': item.recebido ? formatCurrency(item.recebido) : `R$${0}`,
        'Horas': item.horas,
        'Shifts': item.shifts,
        'Faltas': item.faltas,
        'Cancelamentos': item.cancelamentos,
        'Favorito': (item.qtd_fav === null) ? 0 : item.qtd_fav,
        'Block': (item.qtd_block === null) ? 0 : item.qtd_block,
        'Total_Estab': (item.qty_estab === null) ? 0 : item.qty_estab,
        'Resp_Freela': item.contagem_registro ? item.contagem_registro : 0,
        'Resp_Emprego': item.contagem_recrutamento ? item.contagem_recrutamento : 0,
        'Meses Ativo': `${item.meses_ativo != null ? item.meses_ativo : 0} Meses`,
        'Tempo p/ ativar': `${item.tempo_cadastro_liberacao != null ? item.tempo_cadastro_liberacao : 0} Meses`,

      }));

      if (buscarCSV) {
        CSV({
          data: lista,
          download: true,
        });

        setCarregando(false);
        toast.success(`Foram exportados ${lista.length} registros.`);
        setBuscarCSV(false);
        return;
      }

      // setCarteiraProfissionais({ lista, quantidade: resposta.data.quantidade });
      setCarteiraProfissionais({ lista, quantidade: lista.length > 0 ? lista[0].full_count : 0 });
      if (carteiraProfissionais.quantidade === 0) setPagina(1)
    } catch (e) {
      if (buscarCSV) {
        setCarregando(false);
        toast.error('Erro ao Exportar os dados');
        setBuscarCSV(false);
        return;
      }

      toast.error(e.message);
    }
    setCarregando(false);
  }, [
    atributoSelecionado,
    textodigitado,
    data,
    pagina,
    treinamentoSelecionado,
    experienciaSelecionada,
    trabFeitosSelecionado,
    estadoSelecionado,
    orderBy,
    buscarCSV,
    setPagina,
    carteiraProfissionais.quantidade
  ]);

  function download(dados) {
    const blob = new Blob([dados], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('hidden', '');
    a.setAttribute('href', url);
    a.setAttribute('download', 'download.csv');
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a)
  }

  useEffect(() => {
    buscarCarteiraProfissionais();
  }, [buscarCarteiraProfissionais]);

  function abrirEditarProfissional(profissional) {
    setProfissionalEditando(profissional);
    setShowEditarProfissional(true);
  }

  function fecharEditarProfissional() {
    buscarCarteiraProfissionais();
    setShowEditarProfissional(false);
  }

  const activeFilters = useMemo(() => {
    const filters = [];

    if (data) {
      filters.push({
        key: 'data',
        label: `Data: ${data[0].toLocaleDateString()} - ${data[1].toLocaleDateString()}`,
        clear: () => setData(null),
      });
    }

    if (estadoSelecionado) {
      filters.push({
        key: 'estado',
        label: `Estado: ${ufSelecionado || estadoSelecionado}`,
        clear: () => {
          setEstadoSelecionado(undefined);
          setUfSelecionado(undefined);
        }
      });
    }

    if (treinamentoSelecionado) {
      // const treinamento = treinamentos.find((t) => t.id === treinamentoSelecionado);
      filters.push({
        key: 'treinamento',
        label: `${treinamentoSelecionado.length} treinamento(s)`,
        clear: () => setTreinamentoSelecionado(null),
      });
    }

    if (experienciaSelecionada && experienciaSelecionada.length > 0) {
      const experiencias = profissoes.filter((p) => experienciaSelecionada.includes(p.id));
      const label = experiencias.map((e) => e.profissao).join(', ');
      filters.push({
        key: 'experiencia',
        label: `Experiências: ${label}`,
        clear: () => setExperienciaSelecionada([]),
      });
    }

    if (trabFeitosSelecionado && trabFeitosSelecionado.length > 0) {
      const trabalhos = profissoes.filter((p) => trabFeitosSelecionado.includes(p.id));
      const label = trabalhos.map((t) => t.profissao).join(', ');
      filters.push({
        key: 'trabalhos',
        label: `Já trabalhou como: ${label}`,
        clear: () => setTrabFeitosSelecionado([]),
      });
    }

    return filters;
  }, [data, estadoSelecionado, treinamentoSelecionado, experienciaSelecionada, trabFeitosSelecionado, profissoes, treinamentos]);

  function handleDetails(rowData) {
    setExibirDetalhesDialog({
      exibir: true,
      id_profissional: rowData.id,
    });
  }

  return (
    <Container>
      <PageHeader
        title="Carteira Profissionais"
        subtitle="Aqui você pode visualizar a carteira de profissionais."
        actions={

          <Button
            appearance="ghost"
            startIcon={<Attachment />}
            onClick={() => setModalConfirmacao(true)}
          >
            Exportar CSV
          </Button>
        }
      />
      <MetricsCards
        items={[
          {
            title: 'Total Profissionais',
            value: carteiraProfissionais.quantidade,
            icon: <MdOutlinePeopleOutline size="30px" />,
            background: '#EFF6FF',
            color: '#2563EB'
          },
          {
            title: 'Perfil Bom',
            value: '-',
            icon: <IoMdCheckmarkCircleOutline size="30px" />,
            background: '#ECFDF3',
            color: '#16A34A'
          },
          {
            title: 'Certificados',
            value: '-',
            icon: <TbCertificate size="30px" />,
            background: '#F3E8FF',
            color: '#7C3AED'
          },
          {
            title: 'Interessados',
            value: '-',
            icon: <FaRegStar size='30px' />,
            background: '#FFF7ED',
            color: '#EA580C'
          },
        ]}
      />
      <AdvancedFilters
        activeFilters={activeFilters}
        header={
          <>
            <SearchInputTable
              place='Buscar profissional...'
              setTextoDigitado={setTextoDigitado}
              estilo={{ width: '700px' }}
            />
            <SelectPicker
              value={atributoSelecionado}
              placeholder="Selecione o Status"
              searchable={false}
              data={[
                { value: 'nome', label: 'Nome' },
                { value: 'bairro', label: 'Bairro' },
                { value: 'cidade', label: 'Cidade' },
              ]}
              onChange={setAtributoSelecionado}
              style={{ marginLeft: '-5px' }}
              cleanable={false}
            />
          </>
        }
      >

        <InputDataRange ranges={[]} value={data} onChange={setData} />
        <SelectState
          setUfSelecionado={setUfSelecionado}
          selectedState={estadoSelecionado}
          setSelectedStates={setEstadoSelecionado}
        // marginRight
        // style={{ marginRight: '-30px' }}
        />
        <FiltroTreinamentos
          appearance="default"
          style={{ width: 224 }}
          searchable={false}
          data={treinamentos.map((treinamento) => ({
            label: treinamento.treinamento,
            value: treinamento.id,
          }))}
          value={treinamentoSelecionado}
          onChange={(value) => setTreinamentoSelecionado(value)}
        />
        <CheckPicker
          style={{ width: 224 }}
          appearance="default"
          placeholder="Experiências"
          data={profissoes.map((profissao) => ({
            label: profissao.profissao,
            value: profissao.id,
          }))}
          value={experienciaSelecionada}
          onChange={(value) => setExperienciaSelecionada(value)}
        />
        <CheckPicker
          style={{ width: 224 }}
          appearance="default"
          placeholder="Já trabalhou como:"
          data={profissoes.map((profissao) => ({
            label: profissao.profissao,
            value: profissao.id,
          }))}
          value={trabFeitosSelecionado}
          onChange={(value) => setTrabFeitosSelecionado(value)}
        />
      </AdvancedFilters>
      <FlexboxGrid style={{ width: '100%' }}>
        <TablePagination
          carregando={carregando}
          dados={carteiraProfissionais.lista}
          quantidade={carteiraProfissionais.quantidade}
          onChangePage={setPagina}
          setOrderBy={setOrderBy}
          rowHeight={64}
        >
          <Column resizable width={100}>
            <HeaderCell align="center">
              <TableHeaderTooltip label="Ações" tooltip="Ações" />
            </HeaderCell>
            <Cell dataKey="id" style={{ padding: '5px' }}>
              {(rowData) => (
                <ActionCell
                  rowData={rowData}
                  onDetails={handleDetails}
                  onEdit={() => abrirEditarProfissional(rowData.id)}
                // onDelete={handleDelete}
                />
              )}
            </Cell>
          </Column>
          <Column resizable width={320} sortable>
            <HeaderCell align='center'>
              <TableHeaderTooltip label="Profissional" tooltip="Profissional" />
            </HeaderCell>
            <Cell dataKey="Nome">
              {(rowData) => <ProfissionalAddressCell rowData={rowData} />}
            </Cell>
          </Column>
          <Column resizable width={110} sortable>
            <HeaderCell>
              <TableHeaderTooltip label="Avaliacao" tooltip="Avaliacao" />
            </HeaderCell>
            <Cell dataKey="Avaliacao" />
          </Column>
          <Column resizable width={110} sortable>
            <HeaderCell>
              <TableHeaderTooltip label="Recebido" tooltip="Recebido" />
            </HeaderCell>
            <Cell dataKey="Recebido" />
          </Column>
          <Column resizable width={80} sortable>
            <HeaderCell>
              <TableHeaderTooltip label="Horas" tooltip="Horas" />
            </HeaderCell>
            <Cell dataKey="Horas" />
          </Column>
          <Column resizable width={80} sortable>
            <HeaderCell>
              <TableHeaderTooltip label="Shifts" tooltip="Shifts" />
            </HeaderCell>
            <Cell dataKey="Shifts" />
          </Column>
          <Column resizable width={80} sortable>
            <HeaderCell>
              <TableHeaderTooltip label="Faltas" tooltip="Faltas" />
            </HeaderCell>
            <Cell dataKey="Faltas" />
          </Column>
          <Column resizable width={80} sortable>
            <HeaderCell>
              <TableHeaderTooltip label="Cancelamentos" tooltip="Cancelamentos" />
            </HeaderCell>
            <Cell dataKey="Cancelamentos" />
          </Column>
          <Column resizable width={80} sortable>
            {/* <HeaderCell>Fav</HeaderCell> */}
            <HeaderCell>
              <TableHeaderTooltip label="Favoritos" tooltip="Favoritos" />
            </HeaderCell>
            <Cell dataKey="Favorito" />
          </Column>
          <Column resizable width={80} sortable>
            <HeaderCell>
              <TableHeaderTooltip label="Block" tooltip="Quantidade de blocks" />
            </HeaderCell>
            <Cell dataKey="Block" />
          </Column>
          <Column resizable width={80} sortable>
            <HeaderCell>
              <TableHeaderTooltip label="Total Estabelecimentos" tooltip='Total de Estabelecimentos' />
            </HeaderCell>
            <Cell dataKey="Total_Estab" />
          </Column>
          <Column resizable width={80} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Resposta Freelancer' tooltip='Resposta Freelancer' />

            </HeaderCell>
            <Cell dataKey="Resp_Freela" />
          </Column>
          <Column resizable width={80} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Resposta Emprego' tooltip='Resposta Emprego' />
            </HeaderCell>
            <Cell dataKey="Resp_Emprego" />
          </Column>
          <Column resizable width={100}>
            <HeaderCell>
              <TableHeaderTooltip label="Meses Ativo" tooltip="Meses Ativo" />
            </HeaderCell>
            <Cell dataKey="Meses Ativo" />
          </Column>
          <Column resizable width={120}>
            <HeaderCell>
              <TableHeaderTooltip label="Tempo p/ ativar" tooltip="Tempo p/ ativar" />
            </HeaderCell>
            <Cell dataKey="Tempo p/ ativar" />
          </Column>
        </TablePagination>
      </FlexboxGrid>
      <DetalhesCarteiraDialog
        exibir={exibirDetalhesDialog.exibir}
        id_profissional={exibirDetalhesDialog.id_profissional}
        datas={data}
        onFechar={() => setExibirDetalhesDialog({ exibir: false })}
      />
      <EditarProfissional
        idProfissional={profissionalEditando && profissionalEditando}
        showEditarProfissional={showEditarProfissional}
        setShowEditarProfissional={setShowEditarProfissional}
        fecharEditarProfissional={fecharEditarProfissional}
        atualizarLista={buscarCarteiraProfissionais}
      />
      <Modal
        open={modalConfirmacao}
        onClose={() => setModalConfirmacao(false)}
        size="xs"
      >
        <Modal.Header>Gerar Relatório CSV</Modal.Header>
        <Modal.Body>
          <p>
            Deseja realmente gerar o csv dos profissionais com o filtro
            atual?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => setModalConfirmacao(false)}
            appearance="subtle"
          >
            Cancelar
          </Button>
          <Button
            appearance="primary"
            type="button"
            onClick={() => {
              setBuscarCSV(true)
              buscarCarteiraProfissionais();
            }}
          >
            Confirmar
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default CarteiraProfissionais;
